import { Box, FlexBox, Text, TextInline } from '@trmediaab/zebra';
import { formatLargeMoneyValue } from '@trmediaab/zebra-utils';
import PropTypes from 'prop-types';

import { formatRoundDate, roundState } from '~/utils/round';

import {
  BAR_HEIGHT,
  JACKPOT_BAR_HEIGHT,
  RESPONSIVE_BRAND_BAR_HEIGHTS,
} from './constants';
import Weather from './Weather';

const ONE_MILLION = 1_000_000;

const RoundHeader = ({ round }) => (
  <Box>
    <FlexBox
      height={RESPONSIVE_BRAND_BAR_HEIGHTS}
      backgroundColor={`betType.${round.bet_type}.primary`}
    >
      <FlexBox
        justifyContent="center"
        alignItems="center"
        height={RESPONSIVE_BRAND_BAR_HEIGHTS}
        px={{
          xs: '2,5',
          lg: '3',
        }}
        backgroundColor="brands.travrondenSpel"
      >
        <Text
          color="white"
          fontWeight="extraBold"
          fontSize={{ xs: '4', md: '5', lg: '36px' }}
        >
          {round.bet_type}
        </Text>
      </FlexBox>

      <FlexBox
        flex="1"
        justifyContent="space-between"
        alignItems="center"
        gap="3"
        px="3,5"
      >
        <Text
          fontSize={{
            xs: '3',
            md: '4',
            lg: '5',
          }}
          fontWeight="bold"
          color="white"
          lineHeight="tight"
        >
          <TextInline>
            {round.meets.map(meet => meet.track_name).join(' / ')}{' '}
          </TextInline>
          <TextInline
            textTransform="lowercase"
            display={{ xs: 'none', lg: 'inline-block' }}
          >
            {formatRoundDate(round.start_time)}
            {roundState(round.start_time)}
          </TextInline>
        </Text>

        <Weather
          meets={round.meets}
          flexShrink="0"
          display={{
            xs: 'none',
            lg: 'flex',
          }}
        />
      </FlexBox>
    </FlexBox>

    <FlexBox
      flex="1"
      display={{ xs: 'flex', lg: 'none' }}
      justifyContent="space-between"
      alignItems="center"
      height={BAR_HEIGHT}
      px="3"
      bg={`betType.${round.bet_type}.highlight`}
    >
      <TextInline fontWeight="bold" color="brands.travrondenSpel">
        {formatRoundDate(round.start_time)}
        {roundState(round.start_time)}
      </TextInline>

      <Weather color="brands.travrondenSpel" meets={round.meets} />
    </FlexBox>

    {round.jackpot != null && round.jackpot !== '0.00' && (
      <Box
        bg={{
          xs: `betType.${round.bet_type}.primary`,
          lg: `betType.${round.bet_type}.highlight`,
        }}
        pl="3"
      >
        <FlexBox
          alignItems="center"
          height={JACKPOT_BAR_HEIGHT}
          overflowX="hidden"
          gap="3,5"
        >
          {round.jackpot != null &&
            Array.from({ length: 9 }, (_, idx) => (
              <Text
                key={idx}
                fontSize="1"
                textTransform="uppercase"
                fontWeight="bold"
                flexShrink="0"
                color={{
                  xs: `betType.${round.bet_type}.highlight`,
                  lg: `betType.${round.bet_type}.primary`,
                }}
              >
                Jackpott&nbsp;
                {round.jackpot > ONE_MILLION
                  ? formatLargeMoneyValue(round.jackpot).replace('kr', '')
                  : formatLargeMoneyValue(round.jackpot)}
              </Text>
            ))}
        </FlexBox>
      </Box>
    )}
  </Box>
);

RoundHeader.propTypes = {
  round: PropTypes.object.isRequired,
};

export default RoundHeader;
